import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthCard from "../components/AuthShell";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function ChangePasswordPage() {
    const [current, setCurrent] = useState("");
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const { refresh, logout, user } = useAuth();
    const navigate = useNavigate();

    // Pivot Phase 9: se l'utente ha `must_change_password=true` (primo login
    // dopo password temporanea), NON chiediamo la password attuale — usiamo
    // l'endpoint `/force-change-password` che richiede solo la nuova.
    const isForced = !!(user && user.must_change_password);

    const onSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (loading) return;
        setError("");
        if (password.length < 10 || !/[A-Za-z]/.test(password) || !/\d/.test(password)) {
            setError("La password deve avere almeno 10 caratteri, una lettera e una cifra.");
            return;
        }
        if (password !== confirm) {
            setError("Le password non coincidono.");
            return;
        }
        setLoading(true);
        try {
            if (isForced) {
                await api.post("/auth/force-change-password", { new_password: password });
            } else {
                await api.post("/auth/change-password", {
                    current_password: current,
                    new_password: password,
                });
            }
            await refresh();
            navigate("/", { replace: true });
        } catch (err) {
            const msg = err?.response?.data?.detail;
            setError(typeof msg === "string" ? msg : "Errore durante il cambio password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthCard
            title={isForced ? "Imposta la tua password" : "Cambia password"}
            subtitle={
                isForced
                    ? "Hai effettuato l'accesso con una password temporanea. Scegli ora la tua password personale per continuare."
                    : "Per sicurezza, scegli una nuova password personale."
            }
            testId="changepw-shell"
        >
            {user?.email ? (
                <div className="el-note" data-testid="changepw-user-info">
                    Account: <strong>{user.email}</strong>
                </div>
            ) : null}

            <form onSubmit={onSubmit} method="post" action="#" noValidate data-testid="changepw-form">
                {!isForced && (
                    <>
                        <label htmlFor="current-password" className="el-label">Password attuale</label>
                        <input
                            id="current-password"
                            className="el-field"
                            type="password"
                            value={current}
                            onChange={(e) => setCurrent(e.target.value)}
                            placeholder="••••••••••"
                            autoComplete="current-password"
                            required
                            data-testid="changepw-current-input"
                        />
                    </>
                )}

                <label htmlFor="new-password" className="el-label">Nuova password</label>
                <input
                    id="new-password"
                    className="el-field"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Almeno 10 caratteri, 1 lettera e 1 cifra"
                    autoComplete="new-password"
                    required
                    data-testid="changepw-new-input"
                />

                <label htmlFor="confirm-password" className="el-label">Conferma password</label>
                <input
                    id="confirm-password"
                    className="el-field"
                    type="password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    placeholder="••••••••••"
                    autoComplete="new-password"
                    required
                    data-testid="changepw-confirm-input"
                />

                {error ? (
                    <div className="el-err" data-testid="changepw-error">{error}</div>
                ) : null}

                <button
                    type="submit"
                    className="el-btn"
                    disabled={loading}
                    onClick={onSubmit}
                    data-testid="changepw-submit-btn"
                >
                    {loading ? "Salvataggio…" : (isForced ? "Imposta password" : "Aggiorna password")}
                </button>

                <div className="el-foot">
                    <button
                        type="button"
                        onClick={async () => { await logout(); navigate("/login"); }}
                        data-testid="changepw-logout-btn"
                    >
                        Esci
                    </button>
                </div>
            </form>
        </AuthCard>
    );
}
